<template>
    <div>
        <el-form-item>
            <div class="questions">
                <el-collapse class="formset__list">
                    <div v-for="question, i in form.questions" class="formset__item">
                        <el-collapse-item :name="i">
                            <template slot="title">
                                <formset-header :label="`${question.question_pl || 'Nowe pytanie'}`"
                                                :errors="checkForErrors(errors.questions, [i])"
                                                :items.sync="form.questions"
                                                :index="i"/>
                            </template>
                            <el-form-item label="Pytanie"
                                          :error="errors.questions && errors.questions[i] && errors.questions[i]['question']">
                                <el-input v-model="question[addLanguageSuffix('question')]" type="textarea"/>
                            </el-form-item>
                            <el-form-item label="Odpowiedź"
                                          :error="errors.questions && errors.questions[i] && errors.questions[i]['answer']">
                                <wyswig-input v-model="question[addLanguageSuffix('answer')]"/>
                            </el-form-item>
                        </el-collapse-item>
                    </div>
                </el-collapse>
                <el-button @click="addSection">Dodaj pytanie</el-button>
                <div v-if="typeof errors.questions === 'string'" class="el-form-item__error">
                    {{ errors.questions }}
                </div>
            </div>
        </el-form-item>
        <el-form-item label="Grafika po lewej stronie"
                      class="left-image"
                      :error="errors.left_image">
            <image-input-component v-model="form.left_image"/>
        </el-form-item>
        <el-form-item label="Grafika po prawej stronie"
                      :error="errors.right_image">
            <image-input-component v-model="form.right_image"/>
        </el-form-item>
    </div>
</template>
<script>
    import {Tag} from '@/api'

    export default {
        props: ['form', 'errors'],
        methods: {
            addSection () {
                const blankObject = {}
                if (!Array.isArray(this.form.questions)) {
                    this.$emit('update:form', {
                        ...this.form,
                        questions: [
                            blankObject
                        ]
                    })
                } else {
                    this.form.questions.push(blankObject)
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    .left-image {
        margin-top: 30px;
    }
</style>


// WEBPACK FOOTER //
// FAQWidget.vue?f3c67e46